export const mapBackendToForm = (data) => {
  if (!data) return {};

  const dateFields = [
    "proposed_date_time",
    "anaesthesiologist_date",
    "nurse_date",
    "surgeon_date",
    "day_of_surgery_medications"
  ];

  const timeFields = [
    "breath_holding_time",
    "nurse_time",
    "surgeon_time",
    "anaesthesiologist_time",
  ];

  const formattedDates = {};
  dateFields.forEach(field => {
    if (data[field]) {
      if (field === "proposed_date_time") {
        const date = new Date(data[field]);
        if (!isNaN(date.getTime())) {
          formattedDates[field] = date.toISOString().slice(0, 16);
        }
      } else {
        const date = new Date(data[field]);
        if (!isNaN(date.getTime())) {
          formattedDates[field] = date.toISOString().slice(0, 10);
        }
      }
    }
  });

  const formattedTimes = {};
  timeFields.forEach(field => {
    if (data[field]) {
      const [hours, minutes] = data[field].split(':');
      if (hours && minutes) {
        formattedTimes[field] = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
      }
    }
  });
  
  // Ensure we don't return null for text fields
  const sanitized = Object.keys(data).reduce((acc, key) => {
    acc[key] = data[key] === null ? '' : data[key];
    return acc;
  }, {});

  return {
    ...sanitized,
    ...formattedDates,
    ...formattedTimes,
  };
};

export const mapFormToBackend = (formData) => {
  const cleanBase64 = (base64String) => {
    if (!base64String) return '';
    if (base64String.includes(',')) return base64String.split(',')[1];
    return base64String;
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return null;
    try {
      if (typeof dateValue === 'string' && dateValue.includes('T')) return dateValue;
      const date = new Date(dateValue);
      return date.toISOString();
    } catch (e) {
      return null;
    }
  };

  const formatTime = (timeValue) => {
    if (!timeValue) return null;
    try {
      if (typeof timeValue === 'string' && timeValue.includes('T')) {
        const date = new Date(timeValue);
        return date.toTimeString().split(' ')[0];
      }
      if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
        return `${timeValue}:00`;
      }
      if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}:\d{2}$/)) {
        return timeValue;
      }
      return timeValue;
    } catch (e) {
      return null;
    }
  };

  return {
    ...formData,
    hospital_id: 1,
    proposed_date_time: formatDate(formData.proposed_date_time),
    
    // Convert boolean flags to defaults if absent
    previous_hospitalization: formData.previous_hospitalization || false,
    previous_surgery_anesthesia: formData.previous_surgery_anesthesia || false,
    drug_allergy: formData.drug_allergy || false,
    smoking: formData.smoking || false,
    substance_abuse: formData.substance_abuse || false,
    alcoholism: formData.alcoholism || false,
    pregnancy_lactation: formData.pregnancy_lactation || false,
    conscious: formData.conscious || false,
    oriented: formData.oriented || false,
    pallor: formData.pallor || false,
    febrile: formData.febrile || false,
    icterus: formData.icterus || false,
    cyanosis: formData.cyanosis || false,
    clubbing: formData.clubbing || false,
    oedema: formData.oedema || false,
    
    // Times
    breath_holding_time: formatTime(formData.breath_holding_time),
    
    // Signs
    anaesthesiologist_signature: cleanBase64(formData.anaesthesiologist_signature),
    anaesthesiologist_date: formatDate(formData.anaesthesiologist_date),
    anaesthesiologist_time: formatTime(formData.anaesthesiologist_time),

    surgeon_signature: cleanBase64(formData.surgeon_signature),
    surgeon_date: formatDate(formData.surgeon_date),
    surgeon_time: formatTime(formData.surgeon_time),

    nurse_signature: cleanBase64(formData.nurse_signature),
    nurse_date: formatDate(formData.nurse_date),
    nurse_time: formatTime(formData.nurse_time),
  };
};

export const validatePreAnaestheticForm = (formData) => {
  const errors = {};
  const requiredFields = [
    { key: 'pre_op_diagnosis', label: 'Pre-Op Diagnosis' },
    { key: 'proposed_procedure', label: 'Proposed Procedure' },
    { key: 'proposed_date_time', label: 'Proposed Date & Time' },
    { key: 'anaesthesiologist_name', label: 'Anaesthetist Name' },
    { key: 'surgeon_name', label: 'Surgeon Name' },
    { key: 'nurse_name', label: 'Nurse Name' },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};
